import { render, staticRenderFns } from "./pgsuForm.vue?vue&type=template&id=39d027f2&scoped=true&"
import script from "./pgsuForm.vue?vue&type=script&lang=js&"
export * from "./pgsuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d027f2",
  null
  
)

export default component.exports